<script lang="ts">
  import { FlaskConical } from '@lucide/svelte';
  import { fa } from '../i18n/fa';

  /**
   * Only in the test version (docs/staging/design.md, built with VITE_APP_VARIANT=test): its data is
   * not the clinic's, so it must never pass for the real app. The real build never shows it.
   */
  const test = import.meta.env.VITE_APP_VARIANT === 'test';
</script>

{#if test}
  <div role="note" class="sticky top-0 z-50 flex items-center justify-center gap-2 border-b border-warn-line bg-warn-soft px-4 py-1.5 text-sm font-medium text-warn">
    <FlaskConical class="size-4 shrink-0" aria-hidden="true" />
    <span>{fa.app.testVersion}</span>
  </div>
{/if}
